<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="comment-icon" :fill="effectiveFillColor">
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
    />
    <circle v-if="isUnread" cx="20" cy="4" r="4" class="unread-indicator" />
  </svg>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend<Data, {}, Computed, Props>({
  props: {
    isUnread: {
      type: Boolean,
      default: false,
    },
    fillColor: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isDarkMode: false,
    };
  },
  computed: {
    effectiveFillColor() {
      if (this.fillColor) {
        return this.fillColor;
      }
      return this.isDarkMode ? "#ffffff" : "#000000";
    },
  },
  mounted() {
    this.checkDarkMode();
    this.observer = new MutationObserver(this.checkDarkMode);
    this.observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-app-theme"],
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    checkDarkMode() {
      this.isDarkMode = document.documentElement.getAttribute("data-app-theme") === "dark";
    },
  },
});

interface Props {
  isUnread: boolean;
  fillColor: string;
}

interface Data {
  isDarkMode: boolean;
  observer?: MutationObserver;
}

interface Computed {
  effectiveFillColor: string;
}
</script>

<style lang="scss" scoped>
.unread-indicator {
  fill: var(--color-warning);
}
</style>
